const Device = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.9987 13.0001H8.9987M5.66536 1.66675H11.6654V13.0001C11.6654 13.3537 11.5249 13.6928 11.2748 13.9429C11.0248 14.1929 10.6857 14.3334 10.332 14.3334H5.66536C5.31174 14.3334 4.9726 14.1929 4.72256 13.9429C4.47251 13.6928 4.33203 13.3537 4.33203 13.0001V3.00008C4.33203 2.64646 4.47251 2.30732 4.72256 2.05727C4.9726 1.80722 5.31174 1.66675 5.66536 1.66675Z"
        stroke="#777A7A"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default Device;
